// _stopPropagation :: EffectFn1 DOM.Event Unit
export function _stopPropagation(event) {
  event.stopPropagation();
}

const spacesRE = /\s+/;

function splitClasses(classes) {
  return classes.split(spacesRE).filter((x) => x !== "");
}

// _addClass :: EffectFn2 Node ClassName Unit
export function _addClass(node, cls) {
  node.classList.add(...splitClasses(cls));
}

// _initClasses :: EffectFn1 Node (EffectFn1 (Array ClassName) Unit)
export function _initClasses(node) {
  var currentClassSet = {};
  return function (classes) {
    var newClassSet = {};
    for (var i = 0; i < classes.length; i++) {
      for (const class_ of splitClasses(classes[i])) {
        newClassSet[class_] = true;
        if (!currentClassSet[class_]) {
          node.classList.add(class_);
        }
      }
    }
    var oldClasses = Object.keys(currentClassSet);
    for (var i = 0; i < oldClasses.length; i++) {
      var class_ = oldClasses[i];
      if (!newClassSet[class_]) {
        node.classList.remove(class_);
      }
    }
    currentClassSet = newClassSet;
  };
}

export function setProperty(node, property, value) {
  node[property] = value;
}
